// ======================================================================
// File Name       : ContentSubQuestionList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import TableHead from '../../components/TableHead';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';

class ContentSubQuestionList extends Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }

  removeSubQuestion(subQuestionIndex) {
    this.props.handleRemoveSubQuestion(subQuestionIndex);
  }

  editSubQuestion(subQuestionDetail) {
    this.props.openEditSubQuestionDialog(subQuestionDetail);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      subQuestionArray,
      openEditSubQuestionDialog,
      handleRemoveSubQuestion,
      isRegister,
    } = this.props;
    this.refsToValidate = [];
    const thead = [
      { title: '出題順', sortBy: null },
      { title: '小問識別ID', sortBy: null },
      { title: '配点', sortBy: null },
      { title: '操作', sortBy: null },
      { title: '削除', sortBy: null },
    ];

    const subQuestionList =
      subQuestionArray &&
      subQuestionArray.reduce(
        (acc, cur) => {
          const { subQuestionSecernId } = cur;
          acc.bySecernId[subQuestionSecernId] = cur;
          acc.allSecernIds.push(subQuestionSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );

    const { bySecernId, allSecernIds } = subQuestionList;
    let listToTest = '';
    if (allSecernIds && allSecernIds.length) {
      listToTest = allSecernIds.length;
    }

    return (
      <div className={`col-sm-12 margin-top-10 margin-bottom-10 ${isRegister ? 'padding-left-right-clear' : ''}`}>
        {!listToTest &&
          <Col sm={7}>
            <FormControlValidate
              label="小問情報"
              validateType={VALIDATE_TYPE.LABEL}
              value={listToTest}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              required={isRegister}
            />
          </Col>}
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>
            {allSecernIds &&
              allSecernIds.map((subQuestionSecernId, index) => {
                let subAbsolutePoint = 0;
                let subAnswerFormula = 0;
                if (subQuestionSecernId.length) {
                  subAbsolutePoint = bySecernId[subQuestionSecernId].subAbsolutePoint;
                  subAnswerFormula = bySecernId[subQuestionSecernId].subAnswerFormula;
                } else {
                  subAbsolutePoint = subQuestionArray[index].subAbsolutePoint;
                }
                const subQuestionIndexText = `小問${index + 1}`;
                const subQuestionIndex = index;
                return (
                  <tr key={index}>
                    <td>
                      {subQuestionIndexText}
                    </td>
                    <td>
                      {subQuestionSecernId}
                    </td>
                    <td className="text-center">
                      {subAbsolutePoint}
                    </td>
                    <td className="text-center">
                      <Button
                        variant="primary"
                        className="btn-96"
                        onClick={this.editSubQuestion.bind(this, {
                          subQuestionIndex,
                          subQuestionSecernId,
                          subAbsolutePoint,
                          subAnswerFormula,
                        })}
                      >
                        編集
                      </Button>
                    </td>
                    <td className="text-center">
                      <i
                        onClick={this.removeSubQuestion.bind(this, subQuestionIndex)}
                        className="bi bi-trash cursor_pointer"
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ContentSubQuestionList;
